import { render } from "./popconfirm.md?vue&type=template&id=27799c37"
import script from "./popconfirm.md?vue&type=script&lang=js"
export * from "./popconfirm.md?vue&type=script&lang=js"
script.render = render

export default script